import { RestApiService } from "./restApiService"


export const checkGiftingEligibilityService = async (id: string) => {
  try {
    const response = await RestApiService.get(`/users/giftings/check-eligibility/${id}`)
    return response.data;
  } catch (err) {
    console.log(err)
    return err;
  }
}

export const acceptGiftService = async (id: string) => {
  try {
    const response = await RestApiService.post(`/users/giftings/accept/${id}`, {})
    return response.data
  } catch (err) {
    console.log(err)
    return err;
  }
}